import * as React from 'react';
import { useCurrentUser } from '@invitae/cms-blocks';
import { useCountryLocationPrefix } from '@invitae/nucleobase-engine-contentful';
import { CartContext } from '@invitae/physician-cart';

var CART_URL = {
    default: '/testing-options',
    patient: '/testing-options',
    physician: '/start-order/#/cart',
};
var useCart = function () {
    var cartContext = React.useContext(CartContext);
    var currentUser = useCurrentUser();
    var addCountryCodePrefix = useCountryLocationPrefix().addCountryCodePrefix;
    var gotoCartPage = React.useCallback(function () {
        window.location.assign(addCountryCodePrefix(CART_URL[(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) || 'default']));
    }, [currentUser, addCountryCodePrefix]);
    var goToSignInPage = React.useCallback(function () {
        window.location.assign(addCountryCodePrefix('profile/signin/'));
    }, [addCountryCodePrefix]);
    return { apiParameters: cartContext === null || cartContext === void 0 ? void 0 : cartContext.apiParameters, gotoCartPage: gotoCartPage, goToSignInPage: goToSignInPage };
};

export { useCart };
//# sourceMappingURL=Cart.hooks.esm.js.map
